import styled from "styled-components";

export const Button = styled.button(({ position, theme }) => ({
  position: "fixed",
  left: position.x,
  top: position.y,
  width: "50px",
  height: "50px",
  padding: "5px 7px",
  borderRadius: "8px",
  backgroundColor: theme.color.brandPrimary.light,
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,

  [theme.breakpoint.lg()]: {
    width: "70px",
    height: "60px",
    padding: "10px 14px",
  },
}));

export const TitleAccessibilityButton = styled.h1(({ theme }) => ({
  fontSize: "28px",
  fontWeight: 600,
  lineHeight: "150%",
  color: theme.color.neutral["02"],
}));

export const DescriptionAccessibilityButton = styled.h1(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "160%",
  color: theme.color.neutral["02"],
}));

export const CounterAccessibilityButton = styled.h1(({ theme }) => ({
  color: theme.color.brandSecondary.medium,
  lineHeight: "160%",
  fontWeight: 400,
  fontSize: "20px",
}));

export const ContentCounterAccessibilityButton = styled.div(() => ({
  display: "flex",
  gap: "6px",
  marginBottom: "24px",
}));

export const ContentAccessibilityButton = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "left",
  gap: "16px",
  alignSelf: "stretch",
}));
